export const IP_CHECK_TYPE = {
  SIGNUP: 1,
  KL_OPERATOR_ADVANCED_EXECUTIVE_LIST_SEARCH: 2,
}



// WEBPACK FOOTER //
// ./src/constants/IpConstants.js